import { ActionEvent, Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static values = {
    location: String,
  };

  declare readonly locationValue: string;

  navigate(event: ActionEvent) {
    const location = event.params.location ?? this.locationValue;
    const options = event.params.options ?? {};
    Turbo.visit(location, options);
  }
}
